import { render, staticRenderFns } from "./SliderBackground.vue?vue&type=template&id=7b0f35be&scoped=true&"
import script from "./SliderBackground.vue?vue&type=script&lang=js&"
export * from "./SliderBackground.vue?vue&type=script&lang=js&"
import style0 from "./SliderBackground.vue?vue&type=style&index=0&id=7b0f35be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0f35be",
  null
  
)

export default component.exports